// embeddedCheckoutFlag.js
// Single switch deciding whether a checkout opens in the in-page CheckoutSheet
// (Stripe Embedded, keeps the live call alive) or takes the old hosted redirect.
//
// Hosted checkout is a TOP-LEVEL navigation, so the WebView never had to allow
// anything special. Embedded makes Stripe a THIRD-PARTY IFRAME, which needs
// third-party cookies and DOM storage — both default true in react-native-webview,
// but only in a build that actually ships those settings. That risk is why the
// rollout ran web-only first.
//
// Native is ON now. What makes that safe is CheckoutSheet's bail-out: it checks
// for a real <iframe> after IFRAME_READY_TIMEOUT_MS and, when the WebView blocked
// third-party storage and rendered nothing, redirects to the hosted twin session
// the backend creates alongside every embedded one. So the worst case on an old
// app build is the pre-existing hosted flow after a short delay — never a dead
// paying screen.
//
// Watch the `embedded_checkout_fallback` analytics event (reason:
// "iframe_not_mounted") to see how many native users are actually falling back.
// If that rate is high, the shell's WebView is missing domStorageEnabled /
// thirdPartyCookiesEnabled — fix it there rather than reverting this.
export const isEmbeddedCheckoutEnabled = () => {
  // Without a publishable key the sheet can only ever bail to a hosted redirect,
  // so skip the detour and go straight there.
  if (!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY) return false;

  // Kill switch: set REACT_APP_EMBEDDED_CHECKOUT=off to put every surface back on
  // hosted redirects without shipping a code change.
  if (String(process.env.REACT_APP_EMBEDDED_CHECKOUT || "").toLowerCase() === "off") {
    return false;
  }

  // Native included — no isNativeApp() gate any more. To narrow it back to
  // Android only (e.g. if the iOS shell's WebView settings aren't confirmed),
  // re-import isNativeApp from ../utils/nativePermissions and add:
  //   if (isNativeApp() && !/Android/i.test(navigator.userAgent)) return false;

  return true;
};

export default isEmbeddedCheckoutEnabled;
